import { h } from "preact";
import { useContext } from "preact/hooks";
import { Context } from "../lib/globalState";

const UserReactionMenu = ({ obj, isReply = false }) => {
  const {
    state: { color },
  } = useContext(Context);

  return (
    <div
      className={`${isReply ? "react-icons-show-reply" : "react-icons-show"}`}
    >
      <span className="comment-react-ico">
        <span>
          <img
            src={require("../assets/images/love.svg")}
            className="comment-react-emoji"
            style={`background-color: ${color}`}
            height="22"
            width="22"
          />
          <span className="r-name">Love</span>
        </span>

        <span className="r-count">{obj?.love?.length ?? 0}</span>
      </span>
      <span className="comment-react-ico">
        <span>
          <img
            src={require("../assets/images/clap.svg")}
            className="comment-react-emoji"
            style={`background-color: ${color}`}
            height="22"
            width="22"
          />
          <span className="r-name">Clap</span>
        </span>

        <span className="r-count">{obj?.clap?.length ?? 0}</span>
      </span>
      <span className="comment-react-ico">
        <span>
          <img
            src={require("../assets/images/like.svg")}
            className="comment-react-emoji"
            style={`background-color: ${color}`}
            height="22"
            width="22"
          />
          <span className="r-name">Like</span>
        </span>

        <span className="r-count">{obj?.like?.length ?? 0}</span>
      </span>
      <span className="comment-react-ico">
        <span>
          <img
            src={require("../assets/images/dislike.svg")}
            className="comment-react-emoji"
            style={`background-color: ${color}`}
            height="22"
            width="22"
          />

          <span className="r-name">Dislike</span>
        </span>

        <span className="r-count">{obj?.dislike?.length ?? 0}</span>
      </span>
    </div>
  );
};

export default UserReactionMenu;
